import { Controller } from "@hotwired/stimulus"

/**
 * Auto-dismisses an element after a delay.
 * Used for toast notifications that should disappear automatically.
 *
 * Usage:
 *   <div data-controller="auto-dismiss" data-auto-dismiss-delay-value="5000">
 *     Toast content
 *     <button data-action="click->auto-dismiss#dismiss">Close</button>
 *   </div>
 */
export default class extends Controller {
  static values = {
    delay: { type: Number, default: 5000 }
  }

  declare delayValue: number
  private timeoutId: number | null = null

  connect() {
    this.timeoutId = window.setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }
  }

  dismiss() {
    this.element.remove()
  }
}
